import type { AlertTypeName } from '@savvy/constants/generated/gql-enums';

// Agent-generated Canvas documents. They carry actor_kind 'system', so without this
// list they'd render the same AlertCircle as a cash-drift or RMD alert.
// ReadonlySet<string> so callers can test a raw `typeOf`; the literal is still checked
// against AlertTypeName.
export const SI_ALERT_TYPES: ReadonlySet<string> = new Set<AlertTypeName>([
  'meeting_prep_ready',
  'meeting_recap_ready',
]);

// Absent key => no CTA button, which is how every non-SI alert type renders.
export const SI_ALERT_REVIEW_LABELS: Readonly<Partial<Record<AlertTypeName, string>>> = {
  meeting_prep_ready: 'Review prep document',
  meeting_recap_ready: 'Review recap document',
};

export const SI_ALERT_ACKNOWLEDGED_LABEL = 'Prepare in Canvas';

// Lives here rather than in the canvas feature because inbox-card is a dependency of
// it — importing back would cycle. A test pins the document's real name to this.
export const CANVAS_ALERTS_QUERY_NAME = 'CanvasAlerts';
